import * as React from 'react'
import { isPlatform } from '@ionic/react'
import { BarcodeScanner } from '@capacitor-community/barcode-scanner'

function useShopWithSku() {
  const [showScanner, setShowScanner] = React.useState(false)

  const canScanSku = isPlatform('capacitor')

  React.useEffect(() => {
    if (!canScanSku) return

    function handleIonBackButton(ev: any) {
      ev.detail.register(10, () => {
        stopSkuScan()
      })
    }

    document.addEventListener('ionBackButton', handleIonBackButton)

    return () =>
      document.removeEventListener('ionBackButton', handleIonBackButton)
  }, [canScanSku])

  async function getSku() {
    if (await checkSkuPermissions()) {
      BarcodeScanner.hideBackground()
      setShowScanner(true)
      document.documentElement.style.setProperty(
        '--body-background',
        'transparent'
      )

      const result = await BarcodeScanner.startScan()
      return result
    }
  }

  function stopSkuScan() {
    BarcodeScanner.stopScan()
    setShowScanner(false)
    const backgroundColor = getComputedStyle(
      document.documentElement
    ).getPropertyValue('--ion-background-color')
    document.documentElement.style.setProperty(
      '--body-background',
      backgroundColor
    )
  }

  async function checkSkuPermissions() {
    const status = await BarcodeScanner.checkPermission({ force: true })
    return status.granted ?? false
  }

  return {
    canScanSku,
    showScanner,
    getSku,
    stopSkuScan,
    checkSkuPermissions,
  }
}

export { useShopWithSku }
